import { ContainerStatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Container } from "./container.entity";
@Entity('container_log')
export class ContainerLog {

    @PrimaryGeneratedColumn("increment", { name: 'container_log_id' })
    containerLogId: number;

    @Column({
        type: 'enum',
        enum: ContainerStatusEnum,
        nullable: false,
        name: 'status',
        default: ContainerStatusEnum.BOOKED
    })
    containerStatus: ContainerStatusEnum;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => Container, container => container.containerLogInfo, { nullable: false, })
    @JoinColumn({ name: "container_id" })
    containerInfo: Container;

}